import { useMutation, useQuery, useQueryClient } from 'react-query'
import { getErrorString } from 'src/utils'
import { listActiveUsers, logoutUser } from './api'
import { toast } from 'sonner'

// prettier-ignore
export const keys = {
    all: ['ACTIVE_USERS_KEY'] as const,
    usersAll: (orgId: string) => [...keys.all, 'ACTIVE_USERS', orgId] as const,
}

export function useListActiveUsers(
  params: Parameters<typeof listActiveUsers>[0],
) {
  return useQuery(
    keys.usersAll(params.organization),
    () => listActiveUsers(params),
    {
      onError: (error) => toast.error(getErrorString(error)),
    },
  )
}

export function useLogoutUser() {
  const queryClient = useQueryClient()
  return useMutation(logoutUser, {
    onSuccess: (data, params, context) => {
      queryClient.invalidateQueries(keys.usersAll(params.organization))
    },
    onError: (error, params, context) => {
      toast.error(getErrorString(error))
    },
  })
}
